import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "fees-card-background row" }
const _hoisted_2 = { class: "push-10-t" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "text-left push-10 font-weight-bold" }
const _hoisted_5 = {
  key: 0,
  src: "/assets/img/check-mark-white.svg",
  class: "push-10-r"
}
const _hoisted_6 = { class: "text-left push-10 font-weight-bold" }
const _hoisted_7 = {
  key: 0,
  src: "/assets/img/check-mark-white.svg",
  class: "push-10-r"
}
const _hoisted_8 = {
  key: 0,
  class: "text-left push-10 font-weight-bold"
}
const _hoisted_9 = {
  key: 0,
  src: "/assets/img/check-mark-white.svg",
  class: "push-10-r"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.disableIcons)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.ccPercentage) + "% + $0.30 per credit card transaction", 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.disableIcons)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.achPercentage) + "% per ACH transaction, minumum of $0.30", 1 /* TEXT */)
        ]),
        (_ctx.achFeeCap && _ctx.achFeeCap > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (!_ctx.disableIcons)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", null, "Maximum fee of $" + _toDisplayString(_ctx.achFeeCap / 100) + " per ACH transaction", 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}